import type { Analytics } from "../api";

/** Derives Home's four display values from the complete rolling-month response. */
export function calculateRevenueSummary(analytics: Analytics) {
  const days = analytics.revenue.series.map((point) => ({
    date: point.date,
    amount: Number(point.amount) || 0,
  }));
  const total = Number(analytics.revenue.total) || 0;
  const bestDay = days.reduce<(typeof days)[number] | null>(
    (best, day) => best === null || day.amount > best.amount ? day : best,
    null,
  );

  return {
    total,
    dailyAverage: total / 30,
    bestDay,
    lastSevenDays: days.slice(-7).reduce((sum, day) => sum + day.amount, 0),
  };
}
